var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column"},[_c('explorer-keyword')],1),_c('div',{staticClass:"column is-narrow"},[_c('explorer-outlier-toggle')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }